import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["io-btn-round", {'inv': _ctx.inverted}])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(_ctx.icon),
      title: _ctx.title
    }, null, 10, _hoisted_1)
  ], 2))
}